export default __webpack_public_path__ + "static/media/contextual-chocolate-lyte.ada982b3.png";